import React from 'react';
import classNames from 'classnames';
import { Text } from '@ui';
import { translate } from '@utils/i18n';
import './PushDeviceStateNoticeStyles.scss';
const NAMESPACE = 'features.settings.technicians.push_device_status_panel';
/*
 * The keys below are snake_case because they are the facade's state values,
 * arriving verbatim from Rails — axios-case-converter rewrites response *keys*,
 * never values. Renaming them here would mean maintaining a translation table
 * between two spellings of the same seven states, which is exactly the kind of
 * seam a wrong lookup hides in.
 */
/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Icon per state. `none` is informational rather than alarming — a technician
 * who has not opened the app yet is a normal situation, not a fault — while the
 * three failure states and the two disabled states each get an icon matching
 * what they actually mean.
 */
const STATE_ICON = {
    registered: 'fa-solid fa-circle-check',
    none: 'fa-light fa-mobile-slash',
    tenant_disabled: 'fa-light fa-toggle-off',
    tier_disabled: 'fa-light fa-gear',
    unauthorized: 'fa-solid fa-key-skeleton',
    read_failed: 'fa-solid fa-triangle-exclamation',
    unavailable: 'fa-solid fa-plug-circle-xmark'
};
const STATE_TONE = {
    registered: 'ok',
    none: 'info',
    tenant_disabled: 'info',
    tier_disabled: 'info',
    unauthorized: 'warn',
    read_failed: 'warn',
    unavailable: 'warn'
};
/**
 * Says, in plain language, what the current state means and what to do about
 * it. This is the part of the panel that earns its keep: the difference
 * between "the platform is down" and "this environment's API key was rejected"
 * is one support escalation versus one config change, and a generic "error"
 * would hide it.
 */
export function PushDeviceStateNotice({ state, platformError }) {
    const tone = STATE_TONE[state];
    return (React.createElement("div", { className: classNames('push-device-state-notice', `push-device-state-notice--${tone}`), role: "status" },
        React.createElement("i", { className: classNames('push-device-state-notice__icon', STATE_ICON[state]), "aria-hidden": "true" }),
        React.createElement("div", { className: "push-device-state-notice__body" },
            React.createElement(Text, { variant: "body" }, translate(`state_${state}`, { namespace: NAMESPACE })),
            platformError && (React.createElement(Text, { variant: "x-small", className: "push-device-state-notice__detail" }, platformError)))));
}
